import http from "@/shared/config/httpService";

import buildPaginationQueryOpts from '@/shared/sort/sorts';

import { IAppUser } from '@/shared/model/app-user.model';

const baseApiUrl = 'api/app-users';

export default class AppUserService {
  public find(id: number): Promise<IAppUser> {
    return new Promise<IAppUser>((resolve, reject) => {
      http
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      http.get(baseApiUrl + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      http.delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAppUser): Promise<IAppUser> {
    return new Promise<IAppUser>((resolve, reject) => {
      http.post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAppUser): Promise<IAppUser> {
    return new Promise<IAppUser>((resolve, reject) => {
      http.put(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public partialUpdate(entity: IAppUser): Promise<IAppUser> {
    return new Promise<IAppUser>((resolve, reject) => {
      http.patch(`${baseApiUrl}/${entity.id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
